import React, { useState } from 'react';
import { Modal } from '../../common/Modal';
import { images } from 'assets/img/common/common';

const LoginDownloadApp = ({
    actions,
    visible,
}) => {
    const onCloseHandler = () => {
        actions.close();
    }

    return (
        <Modal
            open={visible}
            type={Modal.MODAL_TYPES.warning}
            title="Autorizá este dispositivo"
            canBeDismissed={true}
            className="authentication"
            onClose={onCloseHandler}
        >
            <div className="modal-box authentication">
                <div className="modal-box--content w">
                    <p className="modal-box--data mb-4">
                        Para que operes de forma más segura, necesitamos que primero te descargues la app de Buenbit e inicies sesión desde ahí.
                    </p>
                    <p className="modal-box--data mb-4">
                        Escaneá el código QR con la cámara de tu celular para instalarla
                    </p>
                    <img className="download-qr-stores" src={images.qrStores} alt="Descargar la APP" width={150} />
                </div>
            </div>
        </Modal>
    )
}

export default LoginDownloadApp;
